export function getBody(model?: any): string | null {
  return model ? JSON.stringify(model) : null;
}
